import FrontBusiness from "@/business/FrontBusiness.js";
import getVar from "@/business/livros/copiladores/getVar.js";

const repetidorQuantidade = async function(node, callback, dicionario, debug) {
  let quantidade = getVar(node.params.quantidade, dicionario, false);

  if (typeof quantidade !== 'number') {
    try {
      quantidade = parseInt(quantidade);
    } catch {
      quantidade = 0;
    }
  }

  if (isNaN(quantidade) || quantidade <= 0) {
    return "";
  }

  const key = node.params.nome || 'item';
  const contadorInicial = parseInt(node.params.contador || "0");

  let saida = [];

  for (let i = 0; i < quantidade; i++) {
    const item = i;
    const idx = contadorInicial + i;

    const contexto = {
      ...dicionario,
      [key]: item,
      idx: idx,
      _chave_: key
    };

    if (debug) {
      debug.item = item;
    }

    saida.push(await callback(node.children, contexto, debug));
  }

  return FrontBusiness.formatArray(saida, node.params.separador, node.params.ultimo);
};

export default repetidorQuantidade;
